var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailletter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,1.1c-0.3-0.2-0.7-0.2-1,0l-2,1c-1.8,0.9-3.9,1.4-6,1.4c-2,0-3.5,1.6-3.5,3.6c0,1.1,0.5,2,1.2,2.7l2.3,4.6 c0.2,0.3,0.5,0.6,0.9,0.6h2.5c0.6,0,1-0.4,1-1v-2.5c0.5,0.2,1.1,0.4,1.6,0.7l2,1c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4,0,0.5-0.1 c0.3-0.2,0.5-0.5,0.5-0.9V2C22,1.7,21.8,1.3,21.5,1.1z M20,10.7l-0.6-0.3c-0.8-0.4-1.6-0.7-2.5-1V4.9c0.9-0.3,1.7-0.6,2.5-1L20,3.6 V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,10h-3v2.3c0,1-0.5,2-1.4,2.6c-0.9,0.5-2,0.6-2.9,0.1l-0.8-0.4C18.6,16,17.4,17,15.9,17h-2.5c-1.2,0-2.2-0.6-2.7-1.7 L8.6,11c-0.3-0.3-0.5-0.6-0.7-1H5c-1.7,0-3,1.3-3,3v14c0,1.7,1.3,3,3,3h22c1.7,0,3-1.3,3-3V13C30,11.3,28.7,10,27,10z M24.7,23.2 c0.4,0.4,0.5,1,0.1,1.4C24.6,24.9,24.3,25,24,25c-0.2,0-0.5-0.1-0.7-0.2l-3.9-3.4l-2.8,2.4C16.5,23.9,16.2,24,16,24 s-0.5-0.1-0.7-0.2l-2.8-2.4l-3.9,3.4C8.5,24.9,8.2,25,8,25c-0.3,0-0.6-0.1-0.8-0.3c-0.4-0.4-0.3-1,0.1-1.4l3.7-3.2l-3.7-3.2 c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l7.3,6.4l7.3-6.4c0.4-0.4,1-0.3,1.4,0.1c0.4,0.4,0.3,1-0.1,1.4L20.9,20L24.7,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailletter);
export default __webpack_public_path__ + "static/media/mailletter.01b8686c59a54070c7fee09c4a9b2982.svg";
export { ForwardRef as ReactComponent };